<aside class="container-fluid pt-3 pb-3 pl-1">
  <div class="col-md-12 ml-0 pl-0">
    <server-refresh (refresh)="refresh()"></server-refresh>
      <span class="mr-2 ml-3">
            <button appRequirePermission="admin.all,consent-definition.edit,consent-definition.all"
                    class="btn btn-success btn-sm"
                    (click)="navigateTo(0)">
              <bi name="pencil-square"></bi>
              Add consent definition
            </button>
      </span>
  </div>
</aside>
<server-table>
  <table list-table class="table table-striped table-hover mt-1">
    <thead class="text-light bg-primary">
    <tr>
      <th></th>
      <th>Id</th>
      <th>Name</th>
      <th>Mandatory</th>
      <th>Default text</th>
      <th>Parent name</th>
      <th>Version</th>
      <th>Can client edit</th>
      <th></th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of response?.results" (dblclick)="navigateTo(item.id)">
      <td></td>
      <td>{{item.id}}</td>
      <td>{{item.name}}</td>
      <td>{{item.mandatory}}</td>
      <td>{{item.defaultText}}</td>
      <td>{{item.parentName}}</td>
      <td>{{item.version}}</td>
      <td>{{item.canClientEdit}}</td>
      <td>
        <button type="submit"
                class="btn btn-outline-danger btn-sm"
                (click)="deleteConsent(item.id)"
                appRequirePermission="admin.all,consent-definition.edit,consent-definition.all"
        >Delete</button>
      </td>
      <td></td>
    </tr>
    </tbody>
  </table>
</server-table>

